import { Divider } from '@mui/material';
import { SparkTextField } from 'sharedComponents/SparkForm';
import SectionHeader from '../SparkSectionHeader';

function SparkBasicDetails() {
  return (
    <>
      <SectionHeader headerText='Tell us more about this Spark' />
      <SparkTextField
        name='name'
        label='Name'
        placeholder='Spark Title'
        size={12}
        showCounter={true}
        maxNumber={50}
      />
      <SparkTextField
        name='headline'
        label='Headline'
        placeholder="Write a motivating headline. Example: 'Start a side hustle'"
        size={12}
        showCounter={true}
        maxNumber={50}
      />
      <SparkTextField
        name='shortDescription'
        label='Short Description'
        placeholder='Spark Description'
        size={12}
        multiline={true}
        rows={3}
        showCounter={true}
        maxNumber={150}
      />
      <Divider
        sx={{ width: '100%', marginBottom: '20px', marginTop: '20px' }}
      />
      <SectionHeader headerText='Overview' />
      <SparkTextField
        name='detailedDescription'
        label='Detailed Description'
        placeholder='Spark Description'
        size={12}
        multiline={true}
        showCounter={true}
        maxNumber={1000}
        sx={{
          '& textarea': {
            minHeight: '78px !important',
            maxHeight: '300px !important',
            overflow: 'auto !important',
          },
        }}
      />
    </>
  );
}

export default SparkBasicDetails;
